// This file is generated by `gulp generate-api`

'use strict';

exports.__esModule = true;
exports['default'] = apiReducer;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj['default'] = obj;
    return newObj;
  }
}
var _actions = require('./actions');
var actions = _interopRequireWildcard(_actions);
var _APIQuery = require('./APIQuery');
var _APIQuery2 = _interopRequireDefault(_APIQuery);
var _immutable = require('immutable');
var InitialState = _immutable.Record({
  fetch: _immutable.fromJS({
    application: {
      constraints: {
        query: _APIQuery2['default']({})
      },
      // getIn(['fetch', 'application', 'creditLimit', ]) APIQuery(fetchApplicationCreditLimit)
      creditLimit: {},
      // getIn(['fetch', 'application', 'firstLoanOffer', ]) APIQuery(fetchApplicationFirstLoanOffer)
      firstLoanOffer: {},
      // getIn(['fetch', 'application', 'login', accessId(?)]) APIQuery(fetchApplicationLoginByAccessid)
      login: {},
      // getIn(['fetch', 'application', 'nextLoanOffer', ]) APIQuery(fetchApplicationNextLoanOffer)
      nextLoanOffer: {}
    },
    client: {
      agreements: {
        // getIn(['fetch', 'client', 'agreements', 'preliminary', ]) null
        preliminary: {}
      },
      application: {
        constraints: {
          query: _APIQuery2['default']({})
        },
        // getIn(['fetch', 'client', 'application', 'offer', ]) APIQuery(fetchClientApplicationOffer)
        offer: {},
        proposals: {
          query: _APIQuery2['default']({})
        },
        query: _APIQuery2['default']({})
      },
      bankAccountNumber: {
        query: _APIQuery2['default']({})
      },
      banks: {
        query: _APIQuery2['default']({})
      },
      // getIn(['fetch', 'client', 'check', ]) null
      check: {},
      consents: {
        query: _APIQuery2['default']({})
      },
      discounts: {
        available: {
          query: _APIQuery2['default']({})
        },
        query: _APIQuery2['default']({})
      },
      email: {
        query: _APIQuery2['default']({}),
        rateLimitStatus: {
          query: _APIQuery2['default']({})
        }
      },
      employer: {
        query: _APIQuery2['default']({})
      },
      // getIn(['fetch', 'client', 'generalTerms', ]) null
      generalTerms: {},
      identityDocument: {
        // getIn(['fetch', 'client', 'identityDocument', 'photo', id(?)]) null
        photo: {},
        // getIn(['fetch', 'client', 'identityDocument', 'photos', ]) APIQuery(fetchClientIdentityDocumentPhotos)
        photos: {}
      },
      // getIn(['fetch', 'client', 'legalTerms', ]) null
      legalTerms: {},
      // getIn(['fetch', 'client', 'loans', loanId(?)]) APIQuery(fetchClientLoansByLoanid)
      loans: {},
      missingMandatoryFields: {
        query: _APIQuery2['default']({})
      },
      password: {
        recovery: {
          // getIn(['fetch', 'client', 'password', 'recovery', 'phone', phoneNumber(?)]) APIQuery(fetchClientPasswordRecoveryPhoneByPhonenumber)
          phone: {}
        }
      },
      phone: {
        query: _APIQuery2['default']({}),
        rateLimitStatus: {
          query: _APIQuery2['default']({})
        }
      },
      query: _APIQuery2['default']({}),
      settings: {
        query: _APIQuery2['default']({})
      }
    },
    dictionary: {
      countries: {
        query: _APIQuery2['default']({})
      }
    },
    employment: {
      professions: {
        query: _APIQuery2['default']({})
      }
    },
    // getIn(['fetch', 'firstLoanLegalTerms', ]) null
    firstLoanLegalTerms: {},
    // getIn(['fetch', 'generalTerms', ]) null
    generalTerms: {},
    // getIn(['fetch', 'nextLoanLegalTerms', ]) null
    nextLoanLegalTerms: {},
    registration: {
      query: _APIQuery2['default']({})
    }
  }),
  patch: _immutable.fromJS({
    client: {
      application: {
        query: _APIQuery2['default']({})
      },
      bankAccountNumber: {
        query: _APIQuery2['default']({})
      },
      emailConfirmation: {
        query: _APIQuery2['default']({})
      },
      employer: {
        query: _APIQuery2['default']({})
      },
      missingMandatoryFields: {
        query: _APIQuery2['default']({})
      },
      password: {
        query: _APIQuery2['default']({})
      },
      phone: {
        query: _APIQuery2['default']({})
      },
      phoneConfirmation: {
        query: _APIQuery2['default']({})
      },
      profile: {
        query: _APIQuery2['default']({})
      },
      settings: {
        query: _APIQuery2['default']({})
      }
    }
  }),
  send: _immutable.fromJS({
    client: {
      application: {
        query: _APIQuery2['default']({})
      },
      cookies: {
        query: _APIQuery2['default']({})
      },
      email: {
        query: _APIQuery2['default']({})
      },
      identityDocument: {
        uploadPhoto: {
          query: _APIQuery2['default']({})
        }
      },
      password: {
        recovery: {
          validateCode: {
            query: _APIQuery2['default']({})
          }
        }
      },
      phone: {
        query: _APIQuery2['default']({})
      },
      temporaryPassword: {
        query: _APIQuery2['default']({})
      }
    },
    registration: {
      query: _APIQuery2['default']({})
    },
    token: {
      application: {
        query: _APIQuery2['default']({})
      },
      basic: {
        query: _APIQuery2['default']({})
      }
    }
  })
});
var initialState = new InitialState();
var IS_API_ACTION = /^(DESTROY|FETCH|PATCH|SEND)/;
var IS_START = /_START$/;
var IS_SUCCESS = /_SUCCESS$/;
var IS_ERROR = /_ERROR$/;
var IS_RESET = /_RESET$/;
function apiReducer(state, action) {
  if (state === undefined) state = initialState;
  if (!(state instanceof InitialState)) return initialState.mergeDeep(state);
  if (!IS_API_ACTION.test(action.type)) return state;
  if (IS_START.test(action.type)) switch (action.type) {
    case actions.FETCH_APPLICATION_CONSTRAINTS_START:
      return state.setIn(['fetch', 'application', 'constraints', 'query', 'pending'], true);
    case actions.FETCH_APPLICATION_CREDIT_LIMIT_START:
      return state.setIn(['fetch', 'application', 'creditLimit', action.meta.age.toString(), 'pending'], true);
    case actions.FETCH_APPLICATION_FIRST_LOAN_OFFER_EXTRA_SERVICE_FEE_START:
      return state.setIn(['fetch', 'application', 'firstLoanOffer', 'extraServiceFee', action.meta.amount.toString(), action.meta.extraServiceRequired.toString(), action.meta.term.toString(), 'pending'], true);
    case actions.FETCH_APPLICATION_FIRST_LOAN_OFFER_START:
      return state.setIn(['fetch', 'application', 'firstLoanOffer', action.meta.amount.toString(), action.meta.term.toString(), action.meta.productNumber.toString(), 'pending'], true);
    case actions.FETCH_APPLICATION_LOGIN_BY_ACCESSID_START:
      return state.setIn(['fetch', 'application', 'login', action.meta.accessId.toString(), 'pending'], true);
    case actions.FETCH_APPLICATION_NEXT_LOAN_OFFER_EXTRA_SERVICE_FEE_START:
      return state.setIn(['fetch', 'application', 'nextLoanOffer', 'extraServiceFee', action.meta.amount.toString(), action.meta.extraServiceRequired.toString(), action.meta.term.toString(), 'pending'], true);
    case actions.FETCH_APPLICATION_NEXT_LOAN_OFFER_START:
      return state.setIn(['fetch', 'application', 'nextLoanOffer', action.meta.amount.toString(), action.meta.term.toString(), action.meta.productNumber.toString(), 'pending'], true);
    case actions.FETCH_CLIENT_AGREEMENTS_PRELIMINARY_START:
      return state.setIn(['fetch', 'client', 'agreements', 'preliminary', action.meta.amount.toString(), action.meta.fileType.toString(), action.meta.firstPaymentDueDate.toString(), action.meta.inline.toString(), action.meta.monthlyPayment.toString(), action.meta.term.toString(), 'pending'], true);
    case actions.FETCH_CLIENT_APPLICATION_CONSTRAINTS_START:
      return state.setIn(['fetch', 'client', 'application', 'constraints', 'query', 'pending'], true);
    case actions.FETCH_CLIENT_APPLICATION_OFFER_EXTRA_SERVICE_FEE_START:
      return state.setIn(['fetch', 'client', 'application', 'offer', 'extraServiceFee', action.meta.amount.toString(), action.meta.extraServiceRequired.toString(), action.meta.term.toString(), 'pending'], true);
    case actions.FETCH_CLIENT_APPLICATION_OFFER_START:
      return state.setIn(['fetch', 'client', 'application', 'offer', action.meta.amount.toString(), action.meta.term.toString(), action.meta.productNumber.toString(), 'pending'], true);
    case actions.FETCH_CLIENT_APPLICATION_PROPOSALS_START:
      return state.setIn(['fetch', 'client', 'application', 'proposals', 'query', 'pending'], true);
    case actions.FETCH_CLIENT_APPLICATION_START:
      return state.setIn(['fetch', 'client', 'application', 'query', 'pending'], true);
    case actions.FETCH_CLIENT_BANKS_START:
      return state.setIn(['fetch', 'client', 'banks', 'query', 'pending'], true);
    case actions.FETCH_CLIENT_BANK_ACCOUNT_NUMBER_START:
      return state.setIn(['fetch', 'client', 'bankAccountNumber', 'query', 'pending'], true);
    case actions.FETCH_CLIENT_CHECK_START:
      return state.setIn(['fetch', 'client', 'check', action.meta.affiliateProvider.toString(), action.meta.email.toString(), action.meta.mobilePhone.toString(), action.meta.personalId.toString(), 'pending'], true);
    case actions.FETCH_CLIENT_CONSENTS_START:
      return state.setIn(['fetch', 'client', 'consents', 'query', 'pending'], true);
    case actions.FETCH_CLIENT_DISCOUNTS_AVAILABLE_START:
      return state.setIn(['fetch', 'client', 'discounts', 'available', 'query', 'pending'], true);
    case actions.FETCH_CLIENT_DISCOUNTS_START:
      return state.setIn(['fetch', 'client', 'discounts', 'query', 'pending'], true);
    case actions.FETCH_CLIENT_EMAIL_RATE_LIMIT_STATUS_START:
      return state.setIn(['fetch', 'client', 'email', 'rateLimitStatus', 'query', 'pending'], true);
    case actions.FETCH_CLIENT_EMAIL_START:
      return state.setIn(['fetch', 'client', 'email', 'query', 'pending'], true);
    case actions.FETCH_CLIENT_EMPLOYER_START:
      return state.setIn(['fetch', 'client', 'employer', 'query', 'pending'], true);
    case actions.FETCH_CLIENT_GENERAL_TERMS_START:
      return state.setIn(['fetch', 'client', 'generalTerms', action.meta.inline.toString(), 'pending'], true);
    case actions.FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTOS_START:
      return state.setIn(['fetch', 'client', 'identityDocument', 'photos', action.meta.type.toString(), 'pending'], true);
    case actions.FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTO_BY_ID_START:
      return state.setIn(['fetch', 'client', 'identityDocument', 'photo', action.meta.id.toString(), 'pending'], true);
    case actions.FETCH_CLIENT_LEGAL_TERMS_START:
      return state.setIn(['fetch', 'client', 'legalTerms', action.meta.amount.toString(), action.meta.attachment.toString(), action.meta.extraServiceRequired.toString(), action.meta.term.toString(), 'pending'], true);
    case actions.FETCH_CLIENT_LOANS_BY_LOANID_START:
      return state.setIn(['fetch', 'client', 'loans', action.meta.loanId.toString(), 'pending'], true);
    case actions.FETCH_CLIENT_LOANS_DEBT_PAYMENT_SCHEDULE_BY_LOANID_START:
      return state.setIn(['fetch', 'client', 'loans', 'debtPaymentSchedule', action.meta.loanId.toString(), 'pending'], true);
    case actions.FETCH_CLIENT_LOANS_START:
      return state.setIn(['fetch', 'client', 'loans', 'query', 'pending'], true);
    case actions.FETCH_CLIENT_MISSING_MANDATORY_FIELDS_START:
      return state.setIn(['fetch', 'client', 'missingMandatoryFields', 'query', 'pending'], true);
    case actions.FETCH_CLIENT_PASSWORD_RECOVERY_PHONE_BY_PHONENUMBER_START:
      return state.setIn(['fetch', 'client', 'password', 'recovery', 'phone', action.meta.responseToken.toString(), action.meta.phoneNumber.toString(), 'pending'], true);
    case actions.FETCH_CLIENT_PHONE_RATE_LIMIT_STATUS_START:
      return state.setIn(['fetch', 'client', 'phone', 'rateLimitStatus', 'query', 'pending'], true);
    case actions.FETCH_CLIENT_PHONE_START:
      return state.setIn(['fetch', 'client', 'phone', 'query', 'pending'], true);
    case actions.FETCH_CLIENT_SETTINGS_START:
      return state.setIn(['fetch', 'client', 'settings', 'query', 'pending'], true);
    case actions.FETCH_CLIENT_START:
      return state.setIn(['fetch', 'client', 'query', 'pending'], true);
    case actions.FETCH_DICTIONARY_COUNTRIES_START:
      return state.setIn(['fetch', 'dictionary', 'countries', 'query', 'pending'], true);
    case actions.FETCH_EMPLOYMENT_PROFESSIONS_START:
      return state.setIn(['fetch', 'employment', 'professions', 'query', 'pending'], true);
    case actions.FETCH_FIRST_LOAN_LEGAL_TERMS_START:
      return state.setIn(['fetch', 'firstLoanLegalTerms', action.meta.amount.toString(), action.meta.attachment.toString(), action.meta.extraServiceRequired.toString(), action.meta.productNumber.toString(), action.meta.term.toString(), 'pending'], true);
    case actions.FETCH_GENERAL_TERMS_START:
      return state.setIn(['fetch', 'generalTerms', action.meta.inline.toString(), 'pending'], true);
    case actions.FETCH_NEXT_LOAN_LEGAL_TERMS_START:
      return state.setIn(['fetch', 'nextLoanLegalTerms', action.meta.amount.toString(), action.meta.extraServiceRequired.toString(), action.meta.term.toString(), 'pending'], true);
    case actions.FETCH_REGISTRATION_START:
      return state.setIn(['fetch', 'registration', 'query', 'pending'], true);
    case actions.PATCH_CLIENT_APPLICATION_START:
      return state.setIn(['patch', 'client', 'application', 'query', 'pending'], true);
    case actions.PATCH_CLIENT_BANK_ACCOUNT_NUMBER_START:
      return state.setIn(['patch', 'client', 'bankAccountNumber', 'query', 'pending'], true);
    case actions.PATCH_CLIENT_EMAIL_CONFIRMATION_START:
      return state.setIn(['patch', 'client', 'emailConfirmation', 'query', 'pending'], true);
    case actions.PATCH_CLIENT_EMPLOYER_START:
      return state.setIn(['patch', 'client', 'employer', 'query', 'pending'], true);
    case actions.PATCH_CLIENT_MISSING_MANDATORY_FIELDS_START:
      return state.setIn(['patch', 'client', 'missingMandatoryFields', 'query', 'pending'], true);
    case actions.PATCH_CLIENT_PASSWORD_START:
      return state.setIn(['patch', 'client', 'password', 'query', 'pending'], true);
    case actions.PATCH_CLIENT_PHONE_CONFIRMATION_START:
      return state.setIn(['patch', 'client', 'phoneConfirmation', 'query', 'pending'], true);
    case actions.PATCH_CLIENT_PHONE_START:
      return state.setIn(['patch', 'client', 'phone', 'query', 'pending'], true);
    case actions.PATCH_CLIENT_PROFILE_START:
      return state.setIn(['patch', 'client', 'profile', 'query', 'pending'], true);
    case actions.PATCH_CLIENT_SETTINGS_START:
      return state.setIn(['patch', 'client', 'settings', 'query', 'pending'], true);
    case actions.SEND_CLIENT_APPLICATION_START:
      return state.setIn(['send', 'client', 'application', 'query', 'pending'], true);
    case actions.SEND_CLIENT_COOKIES_START:
      return state.setIn(['send', 'client', 'cookies', 'query', 'pending'], true);
    case actions.SEND_CLIENT_EMAIL_START:
      return state.setIn(['send', 'client', 'email', 'query', 'pending'], true);
    case actions.SEND_CLIENT_IDENTITY_DOCUMENT_UPLOAD_PHOTO_START:
      return state.setIn(['send', 'client', 'identityDocument', 'uploadPhoto', 'query', 'pending'], true);
    case actions.SEND_CLIENT_PASSWORD_RECOVERY_VALIDATE_CODE_START:
      return state.setIn(['send', 'client', 'password', 'recovery', 'validateCode', 'query', 'pending'], true);
    case actions.SEND_CLIENT_PHONE_START:
      return state.setIn(['send', 'client', 'phone', 'query', 'pending'], true);
    case actions.SEND_CLIENT_TEMPORARY_PASSWORD_START:
      return state.setIn(['send', 'client', 'temporaryPassword', 'query', 'pending'], true);
    case actions.SEND_REGISTRATION_START:
      return state.setIn(['send', 'registration', 'query', 'pending'], true);
    case actions.SEND_TOKEN_APPLICATION_START:
      return state.setIn(['send', 'token', 'application', 'query', 'pending'], true);
    case actions.SEND_TOKEN_BASIC_START:
      return state.setIn(['send', 'token', 'basic', 'query', 'pending'], true);
  }
  if (IS_SUCCESS.test(action.type)) switch (action.type) {
    case actions.FETCH_APPLICATION_CONSTRAINTS_SUCCESS:
      return state.setIn(['fetch', 'application', 'constraints', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_APPLICATION_CREDIT_LIMIT_SUCCESS:
      return state.setIn(['fetch', 'application', 'creditLimit', action.meta.age.toString()], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_APPLICATION_FIRST_LOAN_OFFER_EXTRA_SERVICE_FEE_SUCCESS:
      return state.setIn(['fetch', 'application', 'firstLoanOffer', 'extraServiceFee', action.meta.amount.toString(), action.meta.extraServiceRequired.toString(), action.meta.term.toString()], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_APPLICATION_FIRST_LOAN_OFFER_SUCCESS:
      return state.setIn(['fetch', 'application', 'firstLoanOffer', action.meta.amount.toString(), action.meta.term.toString(), action.meta.productNumber.toString()], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_APPLICATION_LOGIN_BY_ACCESSID_SUCCESS:
      return state.setIn(['fetch', 'application', 'login', action.meta.accessId.toString()], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_APPLICATION_NEXT_LOAN_OFFER_EXTRA_SERVICE_FEE_SUCCESS:
      return state.setIn(['fetch', 'application', 'nextLoanOffer', 'extraServiceFee', action.meta.amount.toString(), action.meta.extraServiceRequired.toString(), action.meta.term.toString()], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_APPLICATION_NEXT_LOAN_OFFER_SUCCESS:
      return state.setIn(['fetch', 'application', 'nextLoanOffer', action.meta.amount.toString(), action.meta.term.toString(), action.meta.productNumber.toString()], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_CLIENT_AGREEMENTS_PRELIMINARY_SUCCESS:
      return state.setIn(['fetch', 'client', 'agreements', 'preliminary', action.meta.amount.toString(), action.meta.fileType.toString(), action.meta.firstPaymentDueDate.toString(), action.meta.inline.toString(), action.meta.monthlyPayment.toString(), action.meta.term.toString()], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_CLIENT_APPLICATION_CONSTRAINTS_SUCCESS:
      return state.setIn(['fetch', 'client', 'application', 'constraints', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_CLIENT_APPLICATION_OFFER_EXTRA_SERVICE_FEE_SUCCESS:
      return state.setIn(['fetch', 'client', 'application', 'offer', 'extraServiceFee', action.meta.amount.toString(), action.meta.extraServiceRequired.toString(), action.meta.term.toString()], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_CLIENT_APPLICATION_OFFER_SUCCESS:
      return state.setIn(['fetch', 'client', 'application', 'offer', action.meta.amount.toString(), action.meta.term.toString(), action.meta.productNumber.toString()], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_CLIENT_APPLICATION_PROPOSALS_SUCCESS:
      return state.setIn(['fetch', 'client', 'application', 'proposals', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_CLIENT_APPLICATION_SUCCESS:
      return state.setIn(['fetch', 'client', 'application', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_CLIENT_BANKS_SUCCESS:
      return state.setIn(['fetch', 'client', 'banks', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_CLIENT_BANK_ACCOUNT_NUMBER_SUCCESS:
      return state.setIn(['fetch', 'client', 'bankAccountNumber', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_CLIENT_CHECK_SUCCESS:
      return state.setIn(['fetch', 'client', 'check', action.meta.affiliateProvider.toString(), action.meta.email.toString(), action.meta.mobilePhone.toString(), action.meta.personalId.toString()], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_CLIENT_CONSENTS_SUCCESS:
      return state.setIn(['fetch', 'client', 'consents', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_CLIENT_DISCOUNTS_AVAILABLE_SUCCESS:
      return state.setIn(['fetch', 'client', 'discounts', 'available', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_CLIENT_DISCOUNTS_SUCCESS:
      return state.setIn(['fetch', 'client', 'discounts', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_CLIENT_EMAIL_RATE_LIMIT_STATUS_SUCCESS:
      return state.setIn(['fetch', 'client', 'email', 'rateLimitStatus', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_CLIENT_EMAIL_SUCCESS:
      return state.setIn(['fetch', 'client', 'email', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_CLIENT_EMPLOYER_SUCCESS:
      return state.setIn(['fetch', 'client', 'employer', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_CLIENT_GENERAL_TERMS_SUCCESS:
      return state.setIn(['fetch', 'client', 'generalTerms', action.meta.inline.toString()], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTOS_SUCCESS:
      return state.setIn(['fetch', 'client', 'identityDocument', 'photos', action.meta.type.toString()], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTO_BY_ID_SUCCESS:
      return state.setIn(['fetch', 'client', 'identityDocument', 'photo', action.meta.id.toString()], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_CLIENT_LEGAL_TERMS_SUCCESS:
      return state.setIn(['fetch', 'client', 'legalTerms', action.meta.amount.toString(), action.meta.attachment.toString(), action.meta.extraServiceRequired.toString(), action.meta.term.toString()], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_CLIENT_LOANS_BY_LOANID_SUCCESS:
      return state.setIn(['fetch', 'client', 'loans', action.meta.loanId.toString()], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_CLIENT_LOANS_DEBT_PAYMENT_SCHEDULE_BY_LOANID_SUCCESS:
      return state.setIn(['fetch', 'client', 'loans', 'debtPaymentSchedule', action.meta.loanId.toString()], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_CLIENT_LOANS_SUCCESS:
      return state.setIn(['fetch', 'client', 'loans', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_CLIENT_MISSING_MANDATORY_FIELDS_SUCCESS:
      return state.setIn(['fetch', 'client', 'missingMandatoryFields', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_CLIENT_PASSWORD_RECOVERY_PHONE_BY_PHONENUMBER_SUCCESS:
      return state.setIn(['fetch', 'client', 'password', 'recovery', 'phone', action.meta.responseToken.toString(), action.meta.phoneNumber.toString()], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_CLIENT_PHONE_RATE_LIMIT_STATUS_SUCCESS:
      return state.setIn(['fetch', 'client', 'phone', 'rateLimitStatus', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_CLIENT_PHONE_SUCCESS:
      return state.setIn(['fetch', 'client', 'phone', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_CLIENT_SETTINGS_SUCCESS:
      return state.setIn(['fetch', 'client', 'settings', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_CLIENT_SUCCESS:
      return state.setIn(['fetch', 'client', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_DICTIONARY_COUNTRIES_SUCCESS:
      return state.setIn(['fetch', 'dictionary', 'countries', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_EMPLOYMENT_PROFESSIONS_SUCCESS:
      return state.setIn(['fetch', 'employment', 'professions', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_FIRST_LOAN_LEGAL_TERMS_SUCCESS:
      return state.setIn(['fetch', 'firstLoanLegalTerms', action.meta.amount.toString(), action.meta.attachment.toString(), action.meta.extraServiceRequired.toString(), action.meta.productNumber.toString(), action.meta.term.toString()], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_GENERAL_TERMS_SUCCESS:
      return state.setIn(['fetch', 'generalTerms', action.meta.inline.toString()], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_NEXT_LOAN_LEGAL_TERMS_SUCCESS:
      return state.setIn(['fetch', 'nextLoanLegalTerms', action.meta.amount.toString(), action.meta.extraServiceRequired.toString(), action.meta.term.toString()], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.FETCH_REGISTRATION_SUCCESS:
      return state.setIn(['fetch', 'registration', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.PATCH_CLIENT_APPLICATION_SUCCESS:
      return state.setIn(['patch', 'client', 'application', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.PATCH_CLIENT_BANK_ACCOUNT_NUMBER_SUCCESS:
      return state.setIn(['patch', 'client', 'bankAccountNumber', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.PATCH_CLIENT_EMAIL_CONFIRMATION_SUCCESS:
      return state.setIn(['patch', 'client', 'emailConfirmation', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.PATCH_CLIENT_EMPLOYER_SUCCESS:
      return state.setIn(['patch', 'client', 'employer', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.PATCH_CLIENT_MISSING_MANDATORY_FIELDS_SUCCESS:
      return state.setIn(['patch', 'client', 'missingMandatoryFields', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.PATCH_CLIENT_PASSWORD_SUCCESS:
      return state.setIn(['patch', 'client', 'password', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.PATCH_CLIENT_PHONE_CONFIRMATION_SUCCESS:
      return state.setIn(['patch', 'client', 'phoneConfirmation', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.PATCH_CLIENT_PHONE_SUCCESS:
      return state.setIn(['patch', 'client', 'phone', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.PATCH_CLIENT_PROFILE_SUCCESS:
      return state.setIn(['patch', 'client', 'profile', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.PATCH_CLIENT_SETTINGS_SUCCESS:
      return state.setIn(['patch', 'client', 'settings', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.SEND_CLIENT_APPLICATION_SUCCESS:
      return state.setIn(['send', 'client', 'application', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.SEND_CLIENT_COOKIES_SUCCESS:
      return state.setIn(['send', 'client', 'cookies', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.SEND_CLIENT_EMAIL_SUCCESS:
      return state.setIn(['send', 'client', 'email', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.SEND_CLIENT_IDENTITY_DOCUMENT_UPLOAD_PHOTO_SUCCESS:
      return state.setIn(['send', 'client', 'identityDocument', 'uploadPhoto', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.SEND_CLIENT_PASSWORD_RECOVERY_VALIDATE_CODE_SUCCESS:
      return state.setIn(['send', 'client', 'password', 'recovery', 'validateCode', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.SEND_CLIENT_PHONE_SUCCESS:
      return state.setIn(['send', 'client', 'phone', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.SEND_CLIENT_TEMPORARY_PASSWORD_SUCCESS:
      return state.setIn(['send', 'client', 'temporaryPassword', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.SEND_REGISTRATION_SUCCESS:
      return state.setIn(['send', 'registration', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.SEND_TOKEN_APPLICATION_SUCCESS:
      return state.setIn(['send', 'token', 'application', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
    case actions.SEND_TOKEN_BASIC_SUCCESS:
      return state.setIn(['send', 'token', 'basic', 'query'], _APIQuery2['default']({
        data: action.payload,
        fetched: true
      }));
  }
  if (IS_ERROR.test(action.type)) switch (action.type) {
    case actions.FETCH_APPLICATION_CONSTRAINTS_ERROR:
      return state.setIn(['fetch', 'application', 'constraints', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_APPLICATION_CREDIT_LIMIT_ERROR:
      return state.setIn(['fetch', 'application', 'creditLimit', action.meta.age.toString()], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_APPLICATION_FIRST_LOAN_OFFER_ERROR:
      return state.setIn(['fetch', 'application', 'firstLoanOffer', action.meta.amount.toString(), action.meta.term.toString(), action.meta.productNumber.toString()], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_APPLICATION_FIRST_LOAN_OFFER_EXTRA_SERVICE_FEE_ERROR:
      return state.setIn(['fetch', 'application', 'firstLoanOffer', 'extraServiceFee', action.meta.amount.toString(), action.meta.extraServiceRequired.toString(), action.meta.term.toString()], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_APPLICATION_LOGIN_BY_ACCESSID_ERROR:
      return state.setIn(['fetch', 'application', 'login', action.meta.accessId.toString()], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_APPLICATION_NEXT_LOAN_OFFER_ERROR:
      return state.setIn(['fetch', 'application', 'nextLoanOffer', action.meta.amount.toString(), action.meta.term.toString(), action.meta.productNumber.toString()], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_APPLICATION_NEXT_LOAN_OFFER_EXTRA_SERVICE_FEE_ERROR:
      return state.setIn(['fetch', 'application', 'nextLoanOffer', 'extraServiceFee', action.meta.amount.toString(), action.meta.extraServiceRequired.toString(), action.meta.term.toString()], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_CLIENT_AGREEMENTS_PRELIMINARY_ERROR:
      return state.setIn(['fetch', 'client', 'agreements', 'preliminary', action.meta.amount.toString(), action.meta.fileType.toString(), action.meta.firstPaymentDueDate.toString(), action.meta.inline.toString(), action.meta.monthlyPayment.toString(), action.meta.term.toString()], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_CLIENT_APPLICATION_CONSTRAINTS_ERROR:
      return state.setIn(['fetch', 'client', 'application', 'constraints', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_CLIENT_APPLICATION_ERROR:
      return state.setIn(['fetch', 'client', 'application', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_CLIENT_APPLICATION_OFFER_ERROR:
      return state.setIn(['fetch', 'client', 'application', 'offer', action.meta.amount.toString(), action.meta.term.toString(), action.meta.productNumber.toString()], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_CLIENT_APPLICATION_OFFER_EXTRA_SERVICE_FEE_ERROR:
      return state.setIn(['fetch', 'client', 'application', 'offer', 'extraServiceFee', action.meta.amount.toString(), action.meta.extraServiceRequired.toString(), action.meta.term.toString()], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_CLIENT_APPLICATION_PROPOSALS_ERROR:
      return state.setIn(['fetch', 'client', 'application', 'proposals', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_CLIENT_BANKS_ERROR:
      return state.setIn(['fetch', 'client', 'banks', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_CLIENT_BANK_ACCOUNT_NUMBER_ERROR:
      return state.setIn(['fetch', 'client', 'bankAccountNumber', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_CLIENT_CHECK_ERROR:
      return state.setIn(['fetch', 'client', 'check', action.meta.affiliateProvider.toString(), action.meta.email.toString(), action.meta.mobilePhone.toString(), action.meta.personalId.toString()], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_CLIENT_CONSENTS_ERROR:
      return state.setIn(['fetch', 'client', 'consents', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_CLIENT_DISCOUNTS_AVAILABLE_ERROR:
      return state.setIn(['fetch', 'client', 'discounts', 'available', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_CLIENT_DISCOUNTS_ERROR:
      return state.setIn(['fetch', 'client', 'discounts', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_CLIENT_EMAIL_ERROR:
      return state.setIn(['fetch', 'client', 'email', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_CLIENT_EMAIL_RATE_LIMIT_STATUS_ERROR:
      return state.setIn(['fetch', 'client', 'email', 'rateLimitStatus', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_CLIENT_EMPLOYER_ERROR:
      return state.setIn(['fetch', 'client', 'employer', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_CLIENT_ERROR:
      return state.setIn(['fetch', 'client', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_CLIENT_GENERAL_TERMS_ERROR:
      return state.setIn(['fetch', 'client', 'generalTerms', action.meta.inline.toString()], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTOS_ERROR:
      return state.setIn(['fetch', 'client', 'identityDocument', 'photos', action.meta.type.toString()], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTO_BY_ID_ERROR:
      return state.setIn(['fetch', 'client', 'identityDocument', 'photo', action.meta.id.toString()], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_CLIENT_LEGAL_TERMS_ERROR:
      return state.setIn(['fetch', 'client', 'legalTerms', action.meta.amount.toString(), action.meta.attachment.toString(), action.meta.extraServiceRequired.toString(), action.meta.term.toString()], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_CLIENT_LOANS_BY_LOANID_ERROR:
      return state.setIn(['fetch', 'client', 'loans', action.meta.loanId.toString()], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_CLIENT_LOANS_DEBT_PAYMENT_SCHEDULE_BY_LOANID_ERROR:
      return state.setIn(['fetch', 'client', 'loans', 'debtPaymentSchedule', action.meta.loanId.toString()], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_CLIENT_LOANS_ERROR:
      return state.setIn(['fetch', 'client', 'loans', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_CLIENT_MISSING_MANDATORY_FIELDS_ERROR:
      return state.setIn(['fetch', 'client', 'missingMandatoryFields', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_CLIENT_PASSWORD_RECOVERY_PHONE_BY_PHONENUMBER_ERROR:
      return state.setIn(['fetch', 'client', 'password', 'recovery', 'phone', action.meta.responseToken.toString(), action.meta.phoneNumber.toString()], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_CLIENT_PHONE_ERROR:
      return state.setIn(['fetch', 'client', 'phone', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_CLIENT_PHONE_RATE_LIMIT_STATUS_ERROR:
      return state.setIn(['fetch', 'client', 'phone', 'rateLimitStatus', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_CLIENT_SETTINGS_ERROR:
      return state.setIn(['fetch', 'client', 'settings', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_DICTIONARY_COUNTRIES_ERROR:
      return state.setIn(['fetch', 'dictionary', 'countries', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_EMPLOYMENT_PROFESSIONS_ERROR:
      return state.setIn(['fetch', 'employment', 'professions', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_FIRST_LOAN_LEGAL_TERMS_ERROR:
      return state.setIn(['fetch', 'firstLoanLegalTerms', action.meta.amount.toString(), action.meta.attachment.toString(), action.meta.extraServiceRequired.toString(), action.meta.productNumber.toString(), action.meta.term.toString()], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_GENERAL_TERMS_ERROR:
      return state.setIn(['fetch', 'generalTerms', action.meta.inline.toString()], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_NEXT_LOAN_LEGAL_TERMS_ERROR:
      return state.setIn(['fetch', 'nextLoanLegalTerms', action.meta.amount.toString(), action.meta.extraServiceRequired.toString(), action.meta.term.toString()], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.FETCH_REGISTRATION_ERROR:
      return state.setIn(['fetch', 'registration', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.PATCH_CLIENT_APPLICATION_ERROR:
      return state.setIn(['patch', 'client', 'application', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.PATCH_CLIENT_BANK_ACCOUNT_NUMBER_ERROR:
      return state.setIn(['patch', 'client', 'bankAccountNumber', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.PATCH_CLIENT_EMAIL_CONFIRMATION_ERROR:
      return state.setIn(['patch', 'client', 'emailConfirmation', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.PATCH_CLIENT_EMPLOYER_ERROR:
      return state.setIn(['patch', 'client', 'employer', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.PATCH_CLIENT_MISSING_MANDATORY_FIELDS_ERROR:
      return state.setIn(['patch', 'client', 'missingMandatoryFields', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.PATCH_CLIENT_PASSWORD_ERROR:
      return state.setIn(['patch', 'client', 'password', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.PATCH_CLIENT_PHONE_CONFIRMATION_ERROR:
      return state.setIn(['patch', 'client', 'phoneConfirmation', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.PATCH_CLIENT_PHONE_ERROR:
      return state.setIn(['patch', 'client', 'phone', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.PATCH_CLIENT_PROFILE_ERROR:
      return state.setIn(['patch', 'client', 'profile', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.PATCH_CLIENT_SETTINGS_ERROR:
      return state.setIn(['patch', 'client', 'settings', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.SEND_CLIENT_APPLICATION_ERROR:
      return state.setIn(['send', 'client', 'application', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.SEND_CLIENT_COOKIES_ERROR:
      return state.setIn(['send', 'client', 'cookies', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.SEND_CLIENT_EMAIL_ERROR:
      return state.setIn(['send', 'client', 'email', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.SEND_CLIENT_IDENTITY_DOCUMENT_UPLOAD_PHOTO_ERROR:
      return state.setIn(['send', 'client', 'identityDocument', 'uploadPhoto', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.SEND_CLIENT_PASSWORD_RECOVERY_VALIDATE_CODE_ERROR:
      return state.setIn(['send', 'client', 'password', 'recovery', 'validateCode', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.SEND_CLIENT_PHONE_ERROR:
      return state.setIn(['send', 'client', 'phone', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.SEND_CLIENT_TEMPORARY_PASSWORD_ERROR:
      return state.setIn(['send', 'client', 'temporaryPassword', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.SEND_REGISTRATION_ERROR:
      return state.setIn(['send', 'registration', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.SEND_TOKEN_APPLICATION_ERROR:
      return state.setIn(['send', 'token', 'application', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
    case actions.SEND_TOKEN_BASIC_ERROR:
      return state.setIn(['send', 'token', 'basic', 'query'], _APIQuery2['default']({
        errors: action.payload.errors,
        fetched: true
      }));
  }
  if (IS_RESET.test(action.type)) switch (action.type) {
    case actions.FETCH_APPLICATION_CONSTRAINTS_RESET:
      return action.hardReset ? state.setIn(['fetch', 'application', 'constraints', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'application', 'constraints', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_APPLICATION_CREDIT_LIMIT_RESET:
      return action.hardReset ? state.setIn(['fetch', 'application', 'creditLimit', action.meta.age.toString()], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'application', 'creditLimit', action.meta.age.toString()], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_APPLICATION_FIRST_LOAN_OFFER_EXTRA_SERVICE_FEE_RESET:
      return action.hardReset ? state.setIn(['fetch', 'application', 'firstLoanOffer', 'extraServiceFee', action.meta.amount.toString(), action.meta.extraServiceRequired.toString(), action.meta.term.toString()], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'application', 'firstLoanOffer', 'extraServiceFee', action.meta.amount.toString(), action.meta.extraServiceRequired.toString(), action.meta.term.toString()], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_APPLICATION_FIRST_LOAN_OFFER_RESET:
      return action.hardReset ? state.setIn(['fetch', 'application', 'firstLoanOffer', action.meta.amount.toString(), action.meta.term.toString(), action.meta.productNumber.toString()], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'application', 'firstLoanOffer', action.meta.amount.toString(), action.meta.term.toString(), action.meta.productNumber.toString()], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_APPLICATION_LOGIN_BY_ACCESSID_RESET:
      return action.hardReset ? state.setIn(['fetch', 'application', 'login', action.meta.accessId.toString()], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'application', 'login', action.meta.accessId.toString()], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_APPLICATION_NEXT_LOAN_OFFER_EXTRA_SERVICE_FEE_RESET:
      return action.hardReset ? state.setIn(['fetch', 'application', 'nextLoanOffer', 'extraServiceFee', action.meta.amount.toString(), action.meta.extraServiceRequired.toString(), action.meta.term.toString()], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'application', 'nextLoanOffer', 'extraServiceFee', action.meta.amount.toString(), action.meta.extraServiceRequired.toString(), action.meta.term.toString()], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_APPLICATION_NEXT_LOAN_OFFER_RESET:
      return action.hardReset ? state.setIn(['fetch', 'application', 'nextLoanOffer', action.meta.amount.toString(), action.meta.term.toString(), action.meta.productNumber.toString()], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'application', 'nextLoanOffer', action.meta.amount.toString(), action.meta.term.toString(), action.meta.productNumber.toString()], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_CLIENT_AGREEMENTS_PRELIMINARY_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'agreements', 'preliminary', action.meta.amount.toString(), action.meta.fileType.toString(), action.meta.firstPaymentDueDate.toString(), action.meta.inline.toString(), action.meta.monthlyPayment.toString(), action.meta.term.toString()], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'agreements', 'preliminary', action.meta.amount.toString(), action.meta.fileType.toString(), action.meta.firstPaymentDueDate.toString(), action.meta.inline.toString(), action.meta.monthlyPayment.toString(), action.meta.term.toString()], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_CLIENT_APPLICATION_CONSTRAINTS_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'application', 'constraints', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'application', 'constraints', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_CLIENT_APPLICATION_OFFER_EXTRA_SERVICE_FEE_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'application', 'offer', 'extraServiceFee', action.meta.amount.toString(), action.meta.extraServiceRequired.toString(), action.meta.term.toString()], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'application', 'offer', 'extraServiceFee', action.meta.amount.toString(), action.meta.extraServiceRequired.toString(), action.meta.term.toString()], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_CLIENT_APPLICATION_OFFER_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'application', 'offer', action.meta.amount.toString(), action.meta.term.toString(), action.meta.productNumber.toString()], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'application', 'offer', action.meta.amount.toString(), action.meta.term.toString(), action.meta.productNumber.toString()], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_CLIENT_APPLICATION_PROPOSALS_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'application', 'proposals', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'application', 'proposals', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_CLIENT_APPLICATION_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'application', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'application', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_CLIENT_BANKS_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'banks', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'banks', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_CLIENT_BANK_ACCOUNT_NUMBER_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'bankAccountNumber', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'bankAccountNumber', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_CLIENT_CHECK_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'check', action.meta.affiliateProvider.toString(), action.meta.email.toString(), action.meta.mobilePhone.toString(), action.meta.personalId.toString()], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'check', action.meta.affiliateProvider.toString(), action.meta.email.toString(), action.meta.mobilePhone.toString(), action.meta.personalId.toString()], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_CLIENT_CONSENTS_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'consents', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'consents', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_CLIENT_DISCOUNTS_AVAILABLE_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'discounts', 'available', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'discounts', 'available', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_CLIENT_DISCOUNTS_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'discounts', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'discounts', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_CLIENT_EMAIL_RATE_LIMIT_STATUS_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'email', 'rateLimitStatus', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'email', 'rateLimitStatus', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_CLIENT_EMAIL_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'email', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'email', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_CLIENT_EMPLOYER_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'employer', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'employer', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_CLIENT_GENERAL_TERMS_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'generalTerms', action.meta.inline.toString()], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'generalTerms', action.meta.inline.toString()], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTOS_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'identityDocument', 'photos', action.meta.type.toString()], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'identityDocument', 'photos', action.meta.type.toString()], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTO_BY_ID_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'identityDocument', 'photo', action.meta.id.toString()], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'identityDocument', 'photo', action.meta.id.toString()], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_CLIENT_LEGAL_TERMS_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'legalTerms', action.meta.amount.toString(), action.meta.attachment.toString(), action.meta.extraServiceRequired.toString(), action.meta.term.toString()], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'legalTerms', action.meta.amount.toString(), action.meta.attachment.toString(), action.meta.extraServiceRequired.toString(), action.meta.term.toString()], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_CLIENT_LOANS_BY_LOANID_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'loans', action.meta.loanId.toString()], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'loans', action.meta.loanId.toString()], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_CLIENT_LOANS_DEBT_PAYMENT_SCHEDULE_BY_LOANID_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'loans', 'debtPaymentSchedule', action.meta.loanId.toString()], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'loans', 'debtPaymentSchedule', action.meta.loanId.toString()], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_CLIENT_LOANS_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'loans', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'loans', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_CLIENT_MISSING_MANDATORY_FIELDS_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'missingMandatoryFields', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'missingMandatoryFields', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_CLIENT_PASSWORD_RECOVERY_PHONE_BY_PHONENUMBER_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'password', 'recovery', 'phone', action.meta.responseToken.toString(), action.meta.phoneNumber.toString()], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'password', 'recovery', 'phone', action.meta.responseToken.toString(), action.meta.phoneNumber.toString()], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_CLIENT_PHONE_RATE_LIMIT_STATUS_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'phone', 'rateLimitStatus', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'phone', 'rateLimitStatus', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_CLIENT_PHONE_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'phone', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'phone', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_CLIENT_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_CLIENT_SETTINGS_RESET:
      return action.hardReset ? state.setIn(['fetch', 'client', 'settings', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'client', 'settings', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_DICTIONARY_COUNTRIES_RESET:
      return action.hardReset ? state.setIn(['fetch', 'dictionary', 'countries', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'dictionary', 'countries', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_EMPLOYMENT_PROFESSIONS_RESET:
      return action.hardReset ? state.setIn(['fetch', 'employment', 'professions', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'employment', 'professions', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_FIRST_LOAN_LEGAL_TERMS_RESET:
      return action.hardReset ? state.setIn(['fetch', 'firstLoanLegalTerms', action.meta.amount.toString(), action.meta.attachment.toString(), action.meta.extraServiceRequired.toString(), action.meta.productNumber.toString(), action.meta.term.toString()], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'firstLoanLegalTerms', action.meta.amount.toString(), action.meta.attachment.toString(), action.meta.extraServiceRequired.toString(), action.meta.productNumber.toString(), action.meta.term.toString()], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_GENERAL_TERMS_RESET:
      return action.hardReset ? state.setIn(['fetch', 'generalTerms', action.meta.inline.toString()], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'generalTerms', action.meta.inline.toString()], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_NEXT_LOAN_LEGAL_TERMS_RESET:
      return action.hardReset ? state.setIn(['fetch', 'nextLoanLegalTerms', action.meta.amount.toString(), action.meta.extraServiceRequired.toString(), action.meta.term.toString()], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'nextLoanLegalTerms', action.meta.amount.toString(), action.meta.extraServiceRequired.toString(), action.meta.term.toString()], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.FETCH_REGISTRATION_RESET:
      return action.hardReset ? state.setIn(['fetch', 'registration', 'query'], _APIQuery2['default']({})) : state.mergeIn(['fetch', 'registration', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.PATCH_CLIENT_APPLICATION_RESET:
      return action.hardReset ? state.setIn(['patch', 'client', 'application', 'query'], _APIQuery2['default']({})) : state.mergeIn(['patch', 'client', 'application', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.PATCH_CLIENT_BANK_ACCOUNT_NUMBER_RESET:
      return action.hardReset ? state.setIn(['patch', 'client', 'bankAccountNumber', 'query'], _APIQuery2['default']({})) : state.mergeIn(['patch', 'client', 'bankAccountNumber', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.PATCH_CLIENT_EMAIL_CONFIRMATION_RESET:
      return action.hardReset ? state.setIn(['patch', 'client', 'emailConfirmation', 'query'], _APIQuery2['default']({})) : state.mergeIn(['patch', 'client', 'emailConfirmation', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.PATCH_CLIENT_EMPLOYER_RESET:
      return action.hardReset ? state.setIn(['patch', 'client', 'employer', 'query'], _APIQuery2['default']({})) : state.mergeIn(['patch', 'client', 'employer', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.PATCH_CLIENT_MISSING_MANDATORY_FIELDS_RESET:
      return action.hardReset ? state.setIn(['patch', 'client', 'missingMandatoryFields', 'query'], _APIQuery2['default']({})) : state.mergeIn(['patch', 'client', 'missingMandatoryFields', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.PATCH_CLIENT_PASSWORD_RESET:
      return action.hardReset ? state.setIn(['patch', 'client', 'password', 'query'], _APIQuery2['default']({})) : state.mergeIn(['patch', 'client', 'password', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.PATCH_CLIENT_PHONE_CONFIRMATION_RESET:
      return action.hardReset ? state.setIn(['patch', 'client', 'phoneConfirmation', 'query'], _APIQuery2['default']({})) : state.mergeIn(['patch', 'client', 'phoneConfirmation', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.PATCH_CLIENT_PHONE_RESET:
      return action.hardReset ? state.setIn(['patch', 'client', 'phone', 'query'], _APIQuery2['default']({})) : state.mergeIn(['patch', 'client', 'phone', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.PATCH_CLIENT_PROFILE_RESET:
      return action.hardReset ? state.setIn(['patch', 'client', 'profile', 'query'], _APIQuery2['default']({})) : state.mergeIn(['patch', 'client', 'profile', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.PATCH_CLIENT_SETTINGS_RESET:
      return action.hardReset ? state.setIn(['patch', 'client', 'settings', 'query'], _APIQuery2['default']({})) : state.mergeIn(['patch', 'client', 'settings', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.SEND_CLIENT_APPLICATION_RESET:
      return action.hardReset ? state.setIn(['send', 'client', 'application', 'query'], _APIQuery2['default']({})) : state.mergeIn(['send', 'client', 'application', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.SEND_CLIENT_COOKIES_RESET:
      return action.hardReset ? state.setIn(['send', 'client', 'cookies', 'query'], _APIQuery2['default']({})) : state.mergeIn(['send', 'client', 'cookies', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.SEND_CLIENT_EMAIL_RESET:
      return action.hardReset ? state.setIn(['send', 'client', 'email', 'query'], _APIQuery2['default']({})) : state.mergeIn(['send', 'client', 'email', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.SEND_CLIENT_IDENTITY_DOCUMENT_UPLOAD_PHOTO_RESET:
      return action.hardReset ? state.setIn(['send', 'client', 'identityDocument', 'uploadPhoto', 'query'], _APIQuery2['default']({})) : state.mergeIn(['send', 'client', 'identityDocument', 'uploadPhoto', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.SEND_CLIENT_PASSWORD_RECOVERY_VALIDATE_CODE_RESET:
      return action.hardReset ? state.setIn(['send', 'client', 'password', 'recovery', 'validateCode', 'query'], _APIQuery2['default']({})) : state.mergeIn(['send', 'client', 'password', 'recovery', 'validateCode', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.SEND_CLIENT_PHONE_RESET:
      return action.hardReset ? state.setIn(['send', 'client', 'phone', 'query'], _APIQuery2['default']({})) : state.mergeIn(['send', 'client', 'phone', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.SEND_CLIENT_TEMPORARY_PASSWORD_RESET:
      return action.hardReset ? state.setIn(['send', 'client', 'temporaryPassword', 'query'], _APIQuery2['default']({})) : state.mergeIn(['send', 'client', 'temporaryPassword', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.SEND_REGISTRATION_RESET:
      return action.hardReset ? state.setIn(['send', 'registration', 'query'], _APIQuery2['default']({})) : state.mergeIn(['send', 'registration', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.SEND_TOKEN_APPLICATION_RESET:
      return action.hardReset ? state.setIn(['send', 'token', 'application', 'query'], _APIQuery2['default']({})) : state.mergeIn(['send', 'token', 'application', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
    case actions.SEND_TOKEN_BASIC_RESET:
      return action.hardReset ? state.setIn(['send', 'token', 'basic', 'query'], _APIQuery2['default']({})) : state.mergeIn(['send', 'token', 'basic', 'query'], {
        fetched: false,
        pending: false,
        errors: null
      });
  }
  return state;
}
module.exports = exports['default'];